import {
    Main6BottomContent,
    Main6SectionWrap,
    Main6TopContent,
    Main6BottomItem,
    Main6BottomBtn
} from 'src/styles/views/Main/main6'
import React, {useState} from 'react'
import img6Health1 from 'src/assets/main/main6/main6-1-1.png'
import img6Health2 from 'src/assets/main/main6/main6-1-2.png'
import img6Health3 from 'src/assets/main/main6/main6-1-3.png'
import img6Life1 from 'src/assets/main/main6/main6-2-1.png'
import img6Life2 from 'src/assets/main/main6/main6-2-2.png'
import img6Life3 from 'src/assets/main/main6/main6-2-3.png'
import {CustomBtn} from 'src/styles/common/CommonForm/buttonform'
import useWindowDimensions from 'src/hooks/useGetWindowSize'
import {Swiper, SwiperSlide} from 'swiper/react'
import {useNavigate} from 'react-router-dom'
import {APP_STORE_WARD, IOS_APP_STORE_WARD, MO_APP_STORE_WARD} from 'src/service/constant/url'
import SwiperCore, {Navigation} from 'swiper'
import {COLOR} from "src/service/constant/color";
import {deviceDetection} from "src/service/utils"

const Main6Section = () => {
    SwiperCore.use([Navigation])
    const navigate = useNavigate()
    type BottomContentType = Array<{ title: string, Content: Array<{ imgSrc: string, text: string, idx?: number }> }>
    const BottomContent: BottomContentType = [
        {
            title: '헬스',
            Content: [
                {imgSrc: img6Health1, text: '함께 복용하면 좋은 영양제와 조심해야 할 조합은?', idx: 1},
                {imgSrc: img6Health2, text: '만성두통, 효과적으로 예방하는 방법', idx: 2},
                {imgSrc: img6Health3, text: '찰떡궁합인 줄 알았는데 같이 먹으면 좋지 않은 조합', idx: 3}
            ]
        },
        {
            title: '라이프',
            Content: [
                {imgSrc: img6Life1, text: '푸른 힐링이 가득한 담양 메타쉐쿼이아'},
                {imgSrc: img6Life2, text: '제주 서귀포시, 숲을 산책하며 만난 바다 외돌개'},
                {imgSrc: img6Life3, text: '담양으로 떠나는 힐링여행'}
            ]
        }
    ]
    const [TopContentTab, setTopContentTab] = useState('헬스')
    const FindItem = (element: { title: string }) => {
        return element.title === TopContentTab
    }
    const {width} = useWindowDimensions()

    const onClickAppDownload = () => {
        switch(deviceDetection()){
            case "AOS":
                window.open(width > 1200 ? APP_STORE_WARD : MO_APP_STORE_WARD)
                break
            case "IOS":
                window.open(IOS_APP_STORE_WARD)
                break
        }
    }

    const PageNav = (option: number|undefined) => {
        if (TopContentTab === '헬스') {
            navigate(`/healthExample/${option}`)
        } else {
            return false
        }
    }
    return (
        <Main6SectionWrap>
            <Main6TopContent>
                {width > 1200 ?
                    <h3>소통을 위한 다양한 컨텐츠</h3>
                    : <h3>다양한 컨텐츠</h3>
                }
                <p>헬스, 라이프, 운세 등 소통을 위한 다양한 컨텐츠를 제공합니다.</p>
            </Main6TopContent>
            <Main6BottomContent>
                <section>
                    <Main6BottomBtn
                        color={`${TopContentTab === '헬스' && 'active'}`}
                        onClick={() => setTopContentTab('헬스')}
                    >헬스
                    </Main6BottomBtn>
                    <Main6BottomBtn
                        color={`${TopContentTab === '라이프' && 'active'}`}
                        onClick={() => setTopContentTab('라이프')}
                    >라이프
                    </Main6BottomBtn>
                </section>
                {width > 767
                    ? <div>
                        {BottomContent?.find(FindItem)?.Content.map((option) => (
                            <Main6BottomItem
                                key={option.text}
                                onClick={() => PageNav(option?.idx)}
                                cursorActive={TopContentTab === "헬스" ? "cursor" : "default"}
                            >
                                <img src={option.imgSrc} alt=''/>
                                <p>{option.text}</p>
                            </Main6BottomItem>
                        ))}
                    </div>
                    : <Swiper
                        slidesPerView='auto'
                        spaceBetween={24}
                        centeredSlides
                        navigation
                        loop
                        style={{margin: '0'}}
                    >
                        {BottomContent?.find(FindItem)?.Content.map((option: any) => (
                            <SwiperSlide style={{width: '240px'}} key={option.text}>
                                <Main6BottomItem
                                    key={option.text}
                                    onClick={() => PageNav(option?.idx)}
                                    cursorActive={TopContentTab === "헬스" ? "active" : "default"}
                                >
                                    <img src={option.imgSrc} alt=''/>
                                    <p>{option.text}</p>
                                </Main6BottomItem>
                            </SwiperSlide>
                        ))}
                    </Swiper>}
                {width > 1200 &&
                    <CustomBtn
                        color={COLOR.point1}
                        bgColor={COLOR.white}
                        borderColor={COLOR.point1}
                        marginTop={"0px"}
                        width={"296px"}
                        fontSize={"18px"}
                        height={"48px"}
                        borderRadius={"40px"}
                        fontFamily={"NanumSquareNeoHeavy, sans-serif"}
                        onClick={onClickAppDownload}
                    >
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a>앱 설치하기</a>
                    </CustomBtn>
                }
            </Main6BottomContent>
        </Main6SectionWrap>
    )
}
export default Main6Section
